exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/skill-matrix/edit-skill/edit-skill.component.css
// module id = ../../../../../src/app/skill-matrix/edit-skill/edit-skill.component.css
// module chunks = main